export default __webpack_public_path__ + "static/media/feb2026Dom-th.7c741256.jpg";